// Probe alternatives until one returns a real raw page. A fallback HTML response
// is an unsuccessful candidate, not a fulfilled winner for Promise.any.
export async function resolveEmbeddedPage(paths, fetcher = fetch, signal) {
    if (signal?.aborted) return undefined
    const probes = new AbortController()
    const abort = () => probes.abort()
    signal?.addEventListener('abort', abort, { once: true })
    try {
        const found = await Promise.any([...new Set(paths)].map(async path => {
            const response = await fetcher(path, { signal: probes.signal })
            if (!response.ok) throw new Error('raw page unavailable')
            const html = await response.text()
            if (probes.signal.aborted || html.includes('-- DEFAULT --')) throw new Error('raw page unavailable')
            return path
        }))
        return signal?.aborted ? undefined : found
    } catch {
        return undefined
    } finally {
        signal?.removeEventListener('abort', abort)
        abort()
    }
}
